import { useDispatch, useSelector } from "react-redux";
import PiButton from "../../components/PiButton";
import PropLibrary from "../prop_library/PropLibrary";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";

import {
  selectIsPropLibraryOpen,
  setIsPropLibraryOpen,
} from "../../app/slices/GlobalSlice";
import PropPresetList from "./PropPresetList";
export default function PropPresetsColumn() {
  const isOpen = useSelector(selectIsPropLibraryOpen);
  const dispatch = useDispatch();

  // Adding happens inside the prop library itself now (PropLibraryBody);
  // this column only opens and closes the dialog.

  const addButton = (
    <div className={"px-[18px] h-[40px]"}>
      <PiButton
        variant={"piBlue"}
        onClick={() => {
          dispatch(setIsPropLibraryOpen({ open: true, positionId: "" }));
        }}
      >
        <div
          className={"h-full flex justify-center mx-auto justify-items-center"}
        >
          <div className={"flex gap-[8px] my-auto text-[24px]"}>
            <PersonAddAltOutlinedIcon className={""} fontSize={"inherit"} />
            <div className={"text-[14px] my-auto"}>Add Prop</div>
          </div>
        </div>
      </PiButton>
    </div>
  );

  return (
    <div className={"w-full h-full flex flex-col gap-y-[10px]"}>
      <PropPresetList />
      {addButton}
      <PropLibrary
        title={"Prop Library"}
        isOpen={isOpen}
        onClose={() =>
          dispatch(setIsPropLibraryOpen({ open: false, positionId: "" }))
        }
      />
    </div>
  );
}
